/**
 * Factory for a user enhancer that includes id and optionally email/roles
 */
export function createUserEnhancer(
  getUser: () => { id: string; email?: string; roles?: string[] } | undefined,
) {
  return () => {
    const user = getUser();
    return user ? { user } : {};
  };
}
